export class MaintenanceScheduleListDto {
    public Id: number
    public Name: string
    public Description: string
}

export class MaintenanceScheduleDto extends MaintenanceScheduleListDto {
    public IsActive: boolean = true
    public DuePeriodDatetime: boolean
    public PeriodDatetime?: number
    public DuePeriodHours: boolean
    public PeriodHours?: number
    public DuePeriodOdometer: boolean
    public PeriodOdometer?: number
    public DueAbsoluteDatetime: boolean
    public AbsoluteDatetime: Date
    public DueAbsoluteOdometer: boolean
    public AbsoluteOdometer?: number
    public DueAbsoluteHours: boolean
    public AbsoluteHours?: number
    public NotifySafetyManagers: boolean
    public NotificationDays: number
    public CreatedOn: Date
    public CreatedBy: string

    // Populated by the server on create / update when NotifySafetyManagers newly transitions
    // to true on this save. Lets the page show an admin-notification delivery toast.
    public EmailsSent?: number
    public EmailsFailed?: number
    public UsersWithNoEmail?: number
    public SentToAddresses?: string
    public FailedAddresses?: string
    public FailureReasons?: string
}